import { FC, useState } from 'react';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';
import { BarcodeScannerInput } from './BarcodeScannerInput';

type TBarcodeCaptureDialog = FC<{
  onClose: VoidFunction;
  onDetected: (code: string) => void;
  onSkip?: VoidFunction;
  onBack?: VoidFunction;
  isOpen?: boolean;
}>;

const BarcodeCaptureDialog: TBarcodeCaptureDialog = ({ onClose, onDetected, onSkip, onBack, isOpen = true }) => {
  const lang = useLanguage()[0].BarcodeScanner;
  const [barcode, setBarcode] = useState<string>('');

  return (
    <Dialog
      open={isOpen}
      title={lang.scanBarcode}
      onCancel={onSkip || onClose}
      cancelLabel={onSkip && lang.skipScanning}
      onConfirm={() => onDetected(barcode)}
      confirmDisabled={!barcode}
      onBack={onBack}
    >
      <BarcodeScannerInput onDetected={setBarcode} />
    </Dialog>
  );
};

export default BarcodeCaptureDialog;
